import React from 'react'
import loaderImg from '../assets/loader.gif'
export default function Loaders() {
    return (
        <img className='loader-size' src={loaderImg} alt="" />
    )
}
